// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playerWrapper--xw1K5 {
  display: flex;
  flex-direction: row;
  position: relative;
}
.playerWrapper--xw1K5 ul {
  position: absolute;
  right: 55px;
  background: #FFF;
  z-index: 9999;
  width: auto;
  color: black;
  list-style: none;
  display: flex;
  flex-direction: row;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  box-shadow: var(--bo-ui-video-card-box-sahdow, 0px 4px 12px rgba(0, 0, 0, 0.1));
  border: 2px solid #001550;
}
.playerWrapper--xw1K5 ul.positive--RanUF {
  top: -10px;
}
.playerWrapper--xw1K5 ul.negative--Wu75L {
  top: 50px;
}
.playerWrapper--xw1K5 ul li {
  padding: 0 0.25rem;
}
.playerWrapper--xw1K5 ul li * {
  font-size: 12px;
}
.playerWrapper--xw1K5 > div {
  flex: 1;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  color: transparent;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button svg,
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button path {
  fill: transparent !important;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.positive--RanUF:hover svg,
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.positive--RanUF:hover path {
  stroke: #10B981 !important;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.negative--Wu75L svg {
  rotate: 180deg !important;
  transform: scaleX(-1) !important;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.negative--Wu75L:hover svg,
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.negative--Wu75L:hover path {
  stroke: #DF0000 !important;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.active--jTgMc {
  border-color: #001550;
  background-color: #FFF;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.active--jTgMc.positive--RanUF svg,
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.active--jTgMc.positive--RanUF path {
  stroke: #10B981;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.active--jTgMc.negative--Wu75L svg,
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button.active--jTgMc.negative--Wu75L path {
  stroke: #DF0000;
}
.playerWrapper--xw1K5 .buttonWrapper--PMpIQ button:first-child {
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/feedback/style.module.less"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAJF;AACA;EAMI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,+EAAA;EACA,yBAAA;AAJJ;AAMI;EACE,UAAA;AAJN;AAOI;EACE,SAAA;AALN;AApBA;EA6BM,kBAAA;AANN;AAvBA;EAgCQ,eAAA;AANR;AA1BA;EAsCI,OAAA;AATJ;AA7BA;EA0CI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAVJ;AAnCA;;EAkDQ,4BAAA;AAXR;AAeQ;;EAGI,0BAAA;AAdZ;AAmBM;EAEI,yBAAA;EACA,gCAAA;AAlBV;AAqBQ;;EAGI,0BAAA;AApBZ;AAyBM;EACE,qBAAA;EACA,sBAAA;AAvBR;AAyBQ;;EAGI,eAAA;AAxBZ;AA4BQ;;EAGI,eAAA;AA3BZ;AAgCM;EACE,qBAAA;AA9BR","sourcesContent":["@import \"~@boclips-ui/styles/src/colors\";\n@box-shadow: var(\n  --bo-ui-video-card-box-sahdow,\n  0px 4px 12px rgba(0, 0, 0, 0.1)\n);\n.playerWrapper {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n\n  ul {\n    position: absolute;\n    right: 55px;\n    background: @white;\n    z-index: 9999;\n    width: auto;\n    color: black;\n    list-style: none;\n    display: flex;\n    flex-direction: row;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    box-shadow: @box-shadow;\n    border: 2px solid @blue-900;\n\n    &.positive {\n      top: -10px;\n    }\n\n    &.negative {\n      top: 50px;\n    }\n\n    li {\n      padding: 0 0.25rem;\n\n      * {\n        font-size: 12px;\n      }\n    }\n  }\n\n  > div {\n    flex: 1;\n  }\n\n  .buttonWrapper {\n    display: flex;\n    flex-direction: column;\n    margin-left: 1rem;\n    color: transparent;\n\n    button {\n      svg,\n      path {\n        fill: transparent !important;\n      }\n\n      &.positive {\n        &:hover {\n          svg,\n          path {\n            stroke: @green !important;\n          }\n        }\n      }\n\n      &.negative {\n        svg {\n          rotate: 180deg !important;\n          transform: scaleX(-1) !important;\n        }\n\n        &:hover {\n          svg,\n          path {\n            stroke: @error !important;\n          }\n        }\n      }\n\n      &.active {\n        border-color: @blue-900;\n        background-color: @white;\n\n        &.positive {\n          svg,\n          path {\n            stroke: @green;\n          }\n        }\n\n        &.negative {\n          svg,\n          path {\n            stroke: @error;\n          }\n        }\n      }\n\n      &:first-child {\n        margin-bottom: 0.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playerWrapper": `playerWrapper--xw1K5`,
	"positive": `positive--RanUF`,
	"negative": `negative--Wu75L`,
	"buttonWrapper": `buttonWrapper--PMpIQ`,
	"active": `active--jTgMc`
};
export default ___CSS_LOADER_EXPORT___;
